import React, { useState } from 'react';
import { Box, FormLabel, Typography, useTheme } from '@mui/material';

import UploadIcon from '../../../assets/Images/Upload.svg';
import Dropdown from '../../../components/Dropdown/Dropdown';
import Input from '../../../components/Input/Input';
import './BrandVoice.scss';
import GradientBorderButton from '../../../components/GradientBorderButton/GradientBorderButton';
import useApiService from '../../../services/api.service';
import useToast from '../../../components/Toast/hooks/useToast';

type Props = {
	handleNext?: () => void;
};

const BrandVoice = ({ handleNext }: Props) => {
	const theme = useTheme();
	const isDarkMode = theme.palette.mode === 'dark';
	const APIService = useApiService();
	const toaster: any = useToast();
	const [file, setSelectedFile] = useState<any>();

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const selectedFile = event.target.files?.[0] || null;
		if (selectedFile) {
			setSelectedFile(selectedFile);
		}
	};

	const dropdownConfigs = [
		{ labelName: 'Brand Tone' },
		{ labelName: 'Industry Focus' },
	].map((item) => ({
		...item,
		valueSelector: 'value',
		itemList: ['Overall', 'Grade A', 'Grade B', 'Grade C'],
		name: 'Grade',
		defaultValue: 'Overall',
	}));

	const phraseInputs = [
		{
			label: 'Do use these Phrases',
			placeholder: 'Enter phrases that align with your brand guide...',
		},
		{
			label: 'Don’t use these Phrases',
			placeholder: 'Enter phrases to avoid in email',
		},
	];

	const uploadBrandGuide = async (selectedFile) => {
		console.log(selectedFile);

		try {
			const formData = new FormData();
			formData.append('file', selectedFile);

			await APIService.postFormData(
				{
					url: 'emailgeneration/upload_style_guide',
					data: formData,
				},
				true
			);
		} catch (err) {
			toaster.addToast({
				message: 'Something went wrong',
				timeout: 3000,
				type: 'error',
			});
			console.error(err);
		} finally {
		}
	};

	const onApply = () => {
		if (!file) {
			toaster.addToast({
				message: 'Choose file first',
				timeout: 3000,
				type: 'error',
			});
			return;
		}
		uploadBrandGuide(file);
	};

	return (
		<div
			className='Advertisement_channel_effect'
			style={{ width: '100%', padding: '40px', marginTop: '3rem' }}
		>
			<Typography fontSize={'28px'} fontWeight={600} mb={1}>
				Brand Voice
			</Typography>
			<Box
				className='brand-voice'
				bgcolor={theme.palette.mode === 'dark' ? '#1a1a1a' : '#F4F7FC'}
			>
				<Box className='brand-voice__container'>
					<Typography mb={1}>Upload Brand Guide</Typography>

					<input
						type='file'
						accept='.docx,.pdf'
						onChange={handleFileChange}
						id='csv-upload'
						style={{ display: 'none' }}
					/>
					<label htmlFor='csv-upload' className='brand-voice__upload-label'>
						<Box className='brand-voice__upload-box'>
							<img src={UploadIcon} alt='UploadIcon' className='upload-icon' />
							<Typography className='browse-text'>Browse</Typography>
							<Typography className='upload-hint'>
								Drag and drop brand guide or click to browse
							</Typography>
						</Box>
					</label>
					{file && (
						<Typography variant='body2' sx={{ marginTop: 2 }}>
							Selected file: {file.name}
						</Typography>
					)}

					<Box className='brand-voice__dropdown-row'>
						{dropdownConfigs.map((config, index) => (
							<Box width='30%' key={index}>
								<Dropdown
									{...config}
									label=''
									onChange={(evt: any) => {}}
									outerClass='outerClass'
								/>
							</Box>
						))}
						<Box width='30%'>
							<Input name='' label='Approver Email' containerClass='approver' />
						</Box>
					</Box>

					<Box className='brand-voice__textareas'>
						{phraseInputs.map((input, index) => (
							<Box width='50%' key={index}>
								<FormLabel
									className='brand-voice__form-label'
									style={{ color: theme.palette.text.primary }}
								>
									{input.label}
								</FormLabel>
								<Input
									name=''
									minRows={4}
									multiline
									placeholder={input.placeholder}
								/>
							</Box>
						))}
					</Box>
				</Box>
				<Box display='flex' justifyContent='center' mt={4}>
					<GradientBorderButton
						label='Apply'
						color={theme.palette.text.primary}
						onClick={() => onApply()}
						// onClick={handleNext}
						backgroundColor={isDarkMode ? '#1a1a1a' : '#F4F7FC'}
						padding='5px 50px'
						backgroundImage='unset'
					/>
				</Box>
			</Box>
		</div>
	);
};

export default BrandVoice;
